import { adminActionButtonSx } from 'src/theme/adminActionButton';
import AdminModal from 'src/components/AdminModal';
import React, { useState, useEffect } from 'react';
import {
  Box,
  Stack,
  TextField,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Chip,
  Button
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const EventDetailsModal = ({
  data,
  openEventModal,
  setOpenEventModal,
  onSubmit,
  onClose
}) => {
  // State for form fields

  const [address, setAddress] = useState('');
  const [venue, setVenue] = useState(data.venue);
  const [title, setTitle] = useState(data.title);
  const [name, setName] = useState(data.name);

  const [billTo, setBillTo] = useState(data.billTo);
  const [payTo, setPayTo] = useState(data.payTo);
  const [clientPo, setClientPo] = useState(data.clientPo);
  const [clientEmail, setClientEmail] = useState(data.clientEmail);
  const [ccEmail, setCcEmail] = useState(data.ccEmail);
  const [ccEmails, setCcEmails] = useState(data.ccEmails);
  const [timezone, setTimezone] = useState(data.timezone);

  // Error states
  const [locationsError, setLocationsError] = useState(false);
  const [venueError, setVenueError] = useState(false);
  const [titleerror, setTitleError] = useState(false);
  const [nameerror, setNameError] = useState(false);
  const [billToError, setBillToError] = useState(false);
  const [payToError, setPayToError] = useState(false);
  const [clientEmailError, setClientEmailError] = useState(false);
  const [ccEmailError, setCCEmailError] = useState(false);
  const [timeZoneError, setTimeZoneError] = useState(false);

  // Handle location picker open
  const handleOpen = () => {
    // Implement map location picker functionality here
    console.log('Opening location picker');
  };

  // Email validation function
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Handle adding CC emails
  const handleAddEmail = (e) => {
    if (e.key === 'Enter' && ccEmail.trim()) {
      e.preventDefault();

      if (isValidEmail(ccEmail)) {
        setCcEmails([...ccEmails, ccEmail.trim()]);
        setCcEmail('');
        setCCEmailError(false);
      } else {
        setCCEmailError(true);
      }
    }
  };

  // Handle deleting CC emails
  const handleDeleteEmail = (emailToDelete) => {
    setCcEmails(ccEmails.filter((email) => email !== emailToDelete));
  };

  // Validate form before submission
  const validateForm = () => {
    let isValid = true;

    // if (!address) {
    //   setLocationsError(true);
    //   isValid = false;
    // }

    if (!venue) {
      setVenueError(true);
      isValid = false;
    }

    if (!title) {
      setTitleError(true);
      isValid = false;
    }

    if (!name) {
      setNameError(true);
      isValid = false;
    }

    if (!billTo) {
      setBillToError(true);
      isValid = false;
    }

    if (!payTo) {
      setPayToError(true);
      isValid = false;
    }

    if (!clientEmail || !isValidEmail(clientEmail)) {
      setClientEmailError(true);
      isValid = false;
    }

    if (!timezone) {
      setTimeZoneError(true);
      isValid = false;
    }

    return isValid;
  };

  // Handle form submission
  const handleSubmit = () => {
    if (validateForm()) {
      onSubmit({
        // address,
        venue,
        title,
        name,
        billTo,
        payTo,
        clientPo,
        clientEmail,
        ccEmails,
        timezone
      });
      handleClose();
    }
  };

  // Handle modal close
  const handleClose = () => {
    setOpenEventModal(false);
    if (onClose) onClose();
  };

  return (
    <AdminModal
      open={openEventModal}
      aria-labelledby="event-details-modal"
      aria-describedby="event-details-form"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80%',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 1,
          maxHeight: '90vh',
          overflow: 'auto'
        }}
      >
        <h2>Event Details</h2>
        <Stack>
          <Stack>
            <Stack
              sx={{ display: 'flex', gap: 1, mt: 2, mb: 2 }}
              direction={{ sm: 'column', md: 'row' }}
            >
              {/* <TextField
                onClick={handleOpen}
                fullWidth
                value={address}
                onChange={(e) => {
                  setAddress(e.target.value);
                  setLocationsError(false);
                }}
                size="small"
                id="outlined-end-adornment"
                label="Event Address"
                error={locationsError}
                helperText={locationsError ? 'Location is required' : ''}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <LocationOnIcon
                        sx={{ color: 'green', cursor: 'pointer' }}
                      />
                    </InputAdornment>
                  )
                }}
              /> */}
              <TextField
                fullWidth
                id="outlined-error-helper-text"
                label="Venue"
                name="venue"
                size="small"
                error={venueError}
                helperText={venueError ? 'Venue is required' : ''}
                value={venue}
                onChange={(e) => {
                  setVenue(e.target.value);
                  setVenueError(false);
                }}
              />
              <TextField
                fullWidth
                id="outlined-error-helper-text"
                label="Job Title or Job number"
                size="small"
                error={titleerror}
                helperText={titleerror ? 'Job Title is required' : ''}
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                  setTitleError(false);
                }}
              />
              <TextField
                fullWidth
                id="outlined-error-helper-text"
                label="Event Name"
                size="small"
                error={nameerror}
                helperText={nameerror ? 'Event Name is required' : ''}
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  setNameError(false);
                }}
              />
              <TextField
                fullWidth
                id="outlined-error-helper-text"
                label="Bill To"
                error={billToError}
                helperText={billToError ? 'Bill To is required' : ''}
                size="small"
                value={billTo}
                onChange={(e) => {
                  setBillTo(e.target.value);
                  setBillToError(false);
                }}
              />
              <TextField
                fullWidth
                id="outlined-error-helper-text"
                label="Pay To"
                size="small"
                error={payToError}
                helperText={payToError ? 'Pay To is required' : ''}
                value={payTo}
                onChange={(e) => {
                  setPayTo(e.target.value);
                  setPayToError(false);
                }}
              />
              <TextField
                fullWidth
                id="outlined-error-helper-text"
                label="Client PO"
                size="small"
                value={clientPo}
                onChange={(e) => setClientPo(e.target.value)}
              />
            </Stack>
            <Stack
              sx={{ display: 'flex', gap: 1 }}
              direction={{ sm: 'column', md: 'row' }}
            >
              <TextField
                fullWidth
                id="outlined-error-helper-text"
                label="Client Email"
                size="small"
                error={clientEmailError}
                helperText={clientEmailError ? 'Email is required' : ''}
                value={clientEmail}
                onChange={(e) => {
                  setClientEmail(e.target.value);
                  setClientEmailError(false);
                }}
              />
              <TextField
                fullWidth
                label="CC Emails"
                size="small"
                error={ccEmailError}
                helperText={ccEmailError ? 'Valid email is required' : ''}
                value={ccEmail}
                onChange={(e) => {
                  setCcEmail(e.target.value);
                  setCCEmailError(false);
                }}
                onKeyDown={handleAddEmail}
                placeholder="Press Enter after each email"
              />

              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
                {ccEmails.map((email, index) => (
                  <Chip
                    key={index}
                    label={email}
                    onDelete={() => handleDeleteEmail(email)}
                    color="primary"
                  />
                ))}
              </Box>

              <FormControl size="small" fullWidth error={timeZoneError}>
                <InputLabel id="timezone-select-label">Timezone</InputLabel>
                <Select
                  readOnly
                  labelId="timezone-select-label"
                  id="timezone-select"
                  label="Timezone"
                  value={timezone}
                  onChange={(e) => {
                    setTimezone(e.target.value);
                    setTimeZoneError(false);
                  }}
                  IconComponent={() => null}
                >
                  <MenuItem value="Eastern Standard Time (EST/EDT) - UTC-5 / UTC-4">
                    Eastern Standard Time (EST/EDT) - UTC-5 / UTC-4
                  </MenuItem>
                  <MenuItem value="Central Standard Time (CST/CDT) - UTC-6 / UTC-5">
                    Central Standard Time (CST/CDT) - UTC-6 / UTC-5
                  </MenuItem>
                  <MenuItem value="Mountain Standard Time (MST/MDT) - UTC-7 / UTC-6">
                    Mountain Standard Time (MST/MDT) - UTC-7 / UTC-6
                  </MenuItem>
                  <MenuItem value="Pacific Standard Time (PST/PDT) - UTC-8 / UTC-7">
                    Pacific Standard Time (PST/PDT) - UTC-8 / UTC-7
                  </MenuItem>
                  <MenuItem value="Alaska Standard Time (AKST/AKDT) - UTC-9 / UTC-8">
                    Alaska Standard Time (AKST/AKDT) - UTC-9 / UTC-8
                  </MenuItem>
                  <MenuItem value="Hawaii-Aleutian Standard Time (HST) - UTC-10">
                    Hawaii-Aleutian Standard Time (HST) - UTC-10
                  </MenuItem>
                  <MenuItem value="Atlantic Standard Time (AST) - UTC-4">
                    Atlantic Standard Time (AST) - UTC-4
                  </MenuItem>
                  <MenuItem value="Chamorro Standard Time (ChST) - UTC+10">
                    Chamorro Standard Time (ChST) - UTC+10
                  </MenuItem>
                  <MenuItem value="Pakistan Standard Time (PST) - UTC+5">
                    Pakistan Standard Time (PST) - UTC+5
                  </MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>
                {timeZoneError && (
                  <FormHelperText>Timezone is required</FormHelperText>
                )}
              </FormControl>
            </Stack>
          </Stack>

          <Box
            sx={{ display: 'flex', gap: 1, mt: 3, justifyContent: 'flex-end' }}
          >
            <Button
              onClick={() => {
                handleClose();
              }}
              variant="outlined"
              sx={{
                width: 100,
                borderColor: '#E8BF21',
                borderWidth: 2,
                color: '#000000',
                '&:hover': {
                  borderColor: '#E8BF21',
                  borderWidth: 2,
                  backgroundColor: 'none'
                }
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{
                ...adminActionButtonSx
              }}
              onClick={handleSubmit}
            >
              Save Details
            </Button>
          </Box>
        </Stack>
      </Box>
    </AdminModal>
  );
};

export default EventDetailsModal;
